import { Spinner } from "ui/gluestack/spinner";

export default function LoadingSpinner() {
  return <Spinner size="small" color="#3b82f6" />;
}
